import { useParams } from 'react-router-dom';
import { useSuspenseQuery } from '@tanstack/react-query';
import { useCurrentAccount } from './useCurrentAccount';
import { fetchEngageMessageById } from 'api/engage';
import { accountQueryKeys } from 'queries/account-query-keys';

const useCurrentEngageMessage = () => {
    const { accountId } = useCurrentAccount();
    const { message_id } = useParams<{ message_id: string }>();
    const messageId = parseInt(message_id);

    return useSuspenseQuery({
        queryKey: accountQueryKeys.engageMessageById(accountId, messageId),
        queryFn: () => fetchEngageMessageById(accountId, messageId),
    });
};

export { useCurrentEngageMessage };
